import Request from "../../utils/Request";

const SubmitEnvPassword = (data = {}) => Request.post(`/advisors/submit-env-password`, data);

export default SubmitEnvPassword